var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3999 14.3999C18.3999 13.9028 17.997 13.4999 17.4999 13.4999C17.0028 13.4999 16.5999 13.9028 16.5999 14.3999V17.0999H13.9C13.4029 17.0999 13 17.5028 13 17.9999C13 18.4969 13.4029 18.8999 13.9 18.8999H16.5999V21.5999C16.5999 22.0969 17.0028 22.4999 17.4999 22.4999C17.997 22.4999 18.3999 22.0969 18.3999 21.5999V18.8999H21.1C21.5971 18.8999 22 18.4969 22 17.9999C22 17.5028 21.5971 17.0999 21.1 17.0999H18.3999V14.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f4b635815e9ed0d8fd6e77cb4f614e53.svg";
export { ForwardRef as ReactComponent };